import Home from "./pages/Home";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ConfigProvider } from './config/ConfigProvider';
import GlobalStyles from "./Globalstyles";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <ConfigProvider>
      <BrowserRouter>
        <GlobalStyles />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
